import {makeStyles} from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    radioGroup: {
        gap: 70,
        flexWrap: "nowrap",
        maxWidth: "895px",

        "@media screen and (max-width: 1280px)": {
            gap: 10,
            flexWrap: "wrap",
            maxWidth: "none",
            flexDirection: "column"
        },

        "@media screen and (max-width: 768px)": {
            padding: "0",
        },

        "@media screen and (max-width: 480px)": {
            padding: "0",
            gap: 12
        }
        
    },
    toggleDrawerBtn: {
        display: "flex",
        width: "auto",
        alignItems: "center",
        padding: "0 8px",
        fontSize: 12,

        '&:hover': {
            color: theme.palette.mainButton.blue,
            '& svg': {
                fill: theme.palette.mainButton.blue
            }
        },

        '& svg': {
            transform: "rotate(180deg)",
            marginLeft: 10
        },
    },
    choosePeriodContainer: {
        display: "flex",
        alignItems: "center",
        gap: 20,

        "@media screen and (max-width: 640px)": {
            gap: 8
        },

        "@media screen and (max-width: 480px)": {
            padding: "0 10px"
        }
    },
    rightPartContainer: {
        display: "flex",
        alignItems: "end",
        marginLeft: "auto",
        gap: "32px",
        '& .MuiFormControlLabel-root': {
            margin: 0,
        },

        "@media screen and (max-width: 1280px)": {
            marginLeft: 0
        },

        "@media screen and (max-width: 640px)": {
          gap: 2,
          display: "block"
        },

        "@media screen and (max-width: 480px)": {
            display: "flex",
            padding: "0 10px",
            gap: 10
        }

    },
    choosePeriodLabel: {
        textDecoration: "underline",
        marginRight: 8,
        minWidth: 150,
        marginLeft: 0,
    },
    formControlLabel: {
        fontSize: 14,
        width: 241,
        minWidth: 150,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "10px",
        background: theme.palette.mainButton.contrastText,
        boxShadow: "0px 4px 15px 0px rgba(166, 166, 166, 0.10)",
        padding: "10px 20px",
        gap: "10px",
        '& .MuiTypography-root': {
            color: theme.palette.mainButton.dark,
            textAlign: "center",
            fontSize: 14,
            fontWeight: 400,
            lineHeight: "130%",

            "@media screen and (max-width: 480px)": {
                fontSize: 10,
            }
        },
        '&:hover':{
            background: theme.palette.secondary.light,
            cursor: "pointer",
        },

        "@media screen and (max-width: 768px)": {
            width: "50%",
            minWidth: "auto",
            padding: "8px 0",
        },

        "@media screen and (max-width: 480px)": {
            width: "50%",
            minWidth: "auto",
            padding: "5px 0",
            borderRadius: 5
        }

    },
    formControlLabelActive: {
        fontSize: 14,
        width: 241,
        minWidth: 150,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "10px",
        background: theme.palette.mainButton.darkBlue,
        boxShadow: "0px 4px 15px 0px rgba(166, 166, 166, 0.10)",
        padding: "10px 20px",
        gap: "10px",
        '& .MuiTypography-root': {
            color: theme.palette.mainButton.contrastText,
            textAlign: "center",
            fontSize: 14,
            fontWeight: 400,
            lineHeight: "130%",

            "@media screen and (max-width: 480px)": {
                fontSize: 10,
            }
        },

        "@media screen and (max-width: 768px)": {
            width: "50%",
            minWidth: "auto",
            padding: "8px 0",
        },

        "@media screen and (max-width: 480px)": {
            width: "50%",
            minWidth: "auto",
            padding: "5px 0",
            borderRadius: 5
        }

    },
    geoZonesLabel: {
        background: theme.palette.mainButton.darkBlue,
        '& .MuiFormControlLabel-label.Mui-disabled': {
            color: theme.palette.mainButton.contrastText,
            opacity: .38
        },
        '& .MuiTypography-root': {
            color: theme.palette.mainButton.contrastText
        }
    },
    wrapperAndPeriodContainer: {
        width: "auto",
        display: "flex",
        alignItems: "center",
        gap: "8px",
        borderRadius: "10px",
        padding: "6px 10px 6px 4px",
        boxShadow: "0px 4px 20px 0px rgba(139, 139, 139, 0.15)",
    },
    svgWrapper: {
        width: 16,
        height: 16,
        display: "flex",
        alignItems: "center",
        padding: 0,
    },
    cancelBtn: {
        border: "none",
        backgroundColor: "transparent",
        cursor: "pointer",
        width: "16px",
        height: "16px",
        padding: 0,
    },
    choosePeriodBtnWrapper: {
        display: "flex",
        gap: ".5rem",
        alignItems: "center",

        "@media screen and (max-width: 480px)": {
            paddingTop: 4,
            gap: 7,
        },
    },
    calendarBtn: {
        width: "24px",
        height: "24px",
    },
    calendarBtnInactive: {
        width: "24px",
        height: "24px",
        opacity: "0.5",
    },
    period: {
      fontSize: 12,

      "@media screen and (max-width: 480px)": {
          fontSize: 10,
      },
    },
    periodInactive: {
        fontSize: 12,
        opacity: "0.5"
      },
    chosenPeriod: {
        width: 250,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "14px",
        minWidth: 200,

        "@media screen and (max-width: 640px)": {
            width: "auto",
            minWidth: "auto",
        },
    },
    periodBtn: {
        '&:hover': {
            '& svg path': {
                fill: theme.palette.mainButton.blue
            }
        },
        '&:active': {
            '& svg path': {
                fill: `${theme.palette.mainButton.darkBlue}!important`
            }
        },
        "@media screen and (max-width: 480px)": {
            '& svg': {
                width: 16,
                height: 16
            }
        }
    },
    periodActive: {
        '& svg path': {
            fill: theme.palette.mainButton.blue
        }
    },
    mobileMenu: {
        display: "none",
        "@media screen and (max-width: 480px)": {
            display: "block",
            zIndex: 1111,
            background: "white",
            maxWidth: "100%",
            padding: "0 8px"
        }
    },
    burgerMenuToggler: {
        display: "none",
        "@media screen and (max-width: 480px)": {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginRight: "auto",
            padding: "0 2px"
        }
    },
    togglerRouteTooltips: {
        fontSize: 24,
        maxHeight: 30
    }
}));

export default useStyles;
